export const gtmLandingCTAEvent = (buttonText: string, locale: string, funnelStep: string) => ({
  event: 'cta_click',
  buttonText,
  locale,
  funnelStep,
});

export default gtmLandingCTAEvent;
